import { fullPlayerAdvancedStatsFragment, fullPlayerStatsFragment, playerAllTeamsFragment, playerCareerStatsFragment } from "./player.fragments"

export const allPlayersWithStatsQuery = `
query($season: Int, $includeZPP: Boolean!, $includeReg: Boolean!, $includePost: Boolean!, $limit: Int, $league: String) {
  allPlayers(season: $season, includeZPP: $includeZPP, limit: $limit, league: $league) {
    officialId
    collegeYear
    country
    countryCode
    firstName
    lastName
    lastNameSuffix
    handedness
    injuryDescription
    injuryStatus
    isCaptain
    profileUrl
    experience
    expFromYear
    allYears
    slug
    jerseyNum
    allTeams {
      ...PlayerAllTeamsFragment
    }
    stats (year: $season, segment: regular) @include(if: $includeReg){
      ...FullPlayerStatsFragment
    }
    postStats: stats(year: $season, segment: post) @include(if: $includePost) {
      ...FullPlayerStatsFragment
    }
    champSeries(year: $season) @include(if: $includeZPP) {
      position
      positionName
      team{
        officialId
        locationCode
        location
        position
        positionName
      }
      stats {
        GAA
        assists
        causedTurnovers
        faceoffPct
        faceoffs
        faceoffsLost
        faceoffsWon
        foRecord
        gamesPlayed
        gamesStarted
        goalieLosses
        goalieTies
        goalieWins
        goals
        goalsAgainst
        groundBalls
        numPenalties
        onePointGoals
        scoringPoints
        pim
        pimValue
        plusMinus
        points
        powerPlayGoals
        powerPlayGoalsAgainst
        powerPlayShots
        saa
        savePct
        saves
        scoresAgainst
        shortHandedGoals
        shortHandedGoalsAgainst
        shortHandedShots
        shotPct
        shots
        shotsOnGoal
        shotsOnGoalPct
        tof
        turnovers
        twoPointGoals
        twoPointGoalsAgainst
        twoPointShots
        twoPointShotPct
        twoPointShotsOnGoal
        twoPointShotsOnGoalPct
        twoPtGaa
        touches
        totalPasses
      }
    }
  }
}
  ${fullPlayerStatsFragment}
  ${playerAllTeamsFragment}
`

export const allStatLeadersQuery = `
query($year: Int!, $seasonSegment: SeasonSegment, $statList: [String], $limit: Int){
  playerStatLeaders(year: $year, seasonSegment: $seasonSegment, statList: $statList, limit: $limit) {
    officialId
    profileUrl
    firstName
    lastName
    position
    statType
    slug
    statValue
    playerRank
    jerseyNum
    teamId
    year
  }
}
`

export const fetchPlayerGameLogs = `
query($id: ID, $year: Int) {
  player(id:$id, forYear: $year) {
    officialId
    slug
    currentTeam{
      officialId
    }
    allEvents {
      slugname
      seasonSegment
      startTime
      homeTeam {
        officialId
      }
      awayTeam {
        officialId
      }
      playerEventStats {
        gamesPlayed
        goals
        assists
        points
        turnovers
        shots
        shotPct
        shotsOnGoal
        shotsOnGoalPct
        gamesStarted
        onePointGoals
        twoPointGoals
        saves
        savePct
        goalsAgainst
        twoPointGoalsAgainst
      }
    }
  }
}
`

export const fetchAllTimeLeaderByStat = `
query($stat: String, $limit: Int) {
  careerStats(stat: $stat, limit: $limit) {
    player{
      name
      experience
      allYears
      slug
    }
    gamesPlayed
    points
    goals
    onePointGoals
    twoPointGoals
    assists
    groundBalls
    saves
    faceoffsWon
  }
}
`

export const fetchAllPlayersAdvancedStats = `
query($year: Int, $limit: Int, $league: String){
  allPlayers(season: $year, limit: $limit, includeZPP: false, league: $league) {
    officialId
    firstName
    lastName
    slug
    currentTeam {
      jerseyNum
      position
      officialId
      locationCode
      location
      fullName
      urlLogo
    }
    stats(year: $year, segment: regular) {
      gamesPlayed
      goals
      assists
      shots
      touches
      totalPasses
      turnovers
      passRate
      shotRate
      goalRate
      assistRate
      turnoverRate
    }
    advancedSeasonStats {
      unassistedGoals
      assistedGoals
      settledGoals
      fastbreakGoals
      substitutionGoals
      doorstepGoals
      powerPlayGoals

      assistOpportunities
      settledAssists
      powerPlayAssists
      fastbreakAssists
      dodgeAssists
      pnrAssists

      unassistedShots
      unassistedShotPct
      assistedShots
      assistedShotPct
      pipeShots

      lhShots
      lhGoals
      lhShotPct
      rhShots
      rhGoals
      rhShotPct
    }
  }
}
`

export const singlePlayerForComparison = `
query($id: ID!, $year: Int, $statsYear: Int) {
  player(id: $id, forYear: $year) {
  officialId
    stats (year: $statsYear, segment: regular){
      ...FullPlayerStatsFragment
    }
    postStats: stats(year: $statsYear, segment: post){
      ...FullPlayerStatsFragment
    }
    careerStats {
      ...PlayerCareerStatsFragment
    }
    allSeasonStats {
      year
      seasonSegment
      teamId
      ...FullPlayerStatsFragment
    }
    accolades {
      awardName
      years
    }
    champSeries(year: $statsYear) {
      position
      stats {
        ...FullPlayerStatsFragment
      }
    }
    advancedSeasonStats {
        ...FullPlayerAdvancedStatsFragment
      }
  }
}
  ${fullPlayerStatsFragment}
  ${playerCareerStatsFragment}
  ${fullPlayerAdvancedStatsFragment}
`